import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "./store";

export const useFastshiftDispatch = () => useDispatch<AppDispatch>();
export const useFastshiftSelector: TypedUseSelectorHook<RootState> =
    useSelector;
